import { Controller } from '@hotwired/stimulus'
import { stimulus } from '~/init'

export default class AccordionController extends Controller {
  static values = {
    increaseZIndex: { type: Boolean, default: false }
  }

  static targets = ['button', 'panel']
  static zIndexCounter = 1

  connect () {
    this.panelTargets.forEach(panel => this.closePanel(panel))
  }

  toggle (event) {
    const button = event.currentTarget
    const panel = this.#findPanelByButton(button)
    if (!panel) return

    if (panel.classList.contains('open')) {
      this.closePanel(panel, button)
    } else {
      this.openPanel(panel, button)
    }
  }

  openPanel (panel, button) {
    panel.classList.add('open')
    button?.setAttribute('aria-expanded', 'true')

    this.#scrollToPanel(panel)
    this.#increaseZIndex(panel)
  }

  closePanel (panel, button = null) {
    panel.classList.remove('open')
    button?.setAttribute('aria-expanded', 'false')

    this.#reduceZIndex(panel)
  }

  #findPanelByButton (button) {
    const targetSelector = button.dataset.accordionTarget
    return this.panelTargets.find(p => `#${p.id}` === targetSelector)
  }

  #scrollToPanel (panel) {
    if (!panel) return
    setTimeout(() => {
      panel.scrollIntoView({ behavior: 'smooth', block: 'center' })
    }, 300)
  }

  #increaseZIndex (panel) {
    if (!this.increaseZIndexValue) return

    panel.style.zIndex = AccordionController.zIndexCounter++
  }

  #reduceZIndex () {
    if (!this.increaseZIndexValue) return

    AccordionController.zIndexCounter--
    if (AccordionController.zIndexCounter < 1) {
      AccordionController.zIndexCounter = 1
    }
  }
}

stimulus.register('accordion', AccordionController)
